module.exports = __webpack_public_path__ + "img/vip_huangjin.90addee9.png";